import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { ApiServiceBase } from './ApiServiceBase';
import { ProductIdentificationResponse } from '../common/IdentifyProductResponse';
import { IdentifyProductRequest } from '../common/IdentifyProductRequest';

@Injectable({
  providedIn: 'root',
})
export class ProductIdentificationService extends ApiServiceBase {
  protected readonly path = 'productidentification';

  identifyProduct(requestModel: IdentifyProductRequest): Observable<ProductIdentificationResponse> {
    return this.http
      .post<ProductIdentificationResponse>(this.getUrl(), requestModel)
      .pipe(
        tap(() => {})
      );
  }
}
